module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAc0lEQVR4AWMYJMDe8D/D1JL/DDPLScNI4D+DkvR/hu4c8g0AYz7u/wzlMeQZAMcszP8ZYtzJNQCBiQCD1QBWBsb/lVxi/88JqhHCmAYIM7H8n8crC5Ik3QAdFo7/O/iVQBKkGxDAzv//pKAqSJA0A4YHAAB4Jkngco7ZSAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/KW.png
// module id = 1186
// module chunks = 0